<template>
  <div style="supplier-bank">
    <van-popup v-model="show" :overlay="false" position="top" :style="{ height: '100%'}" :lock-scroll="true" :closeable="true" @close="close">
      <div style="height:40px;text-align:center;font-size:16px;line-height:36px;color:#EE7700">添加供应商收款账号</div>
      <van-form @submit="onSubmit" ref="sAddressForm">
        <van-field v-model="SupplierId" name="SupplierId" style="display:none"/>
        <van-field required v-model="SupplierName" name="SupplierName" label="供应商名称" readonly/>
        <van-field required v-model="ContactName" name="ContactName" label="联系人名称" label-width="130" placeholder="请输入联系人名称" :rules="[{ required: true, message: '请填写联系人名称' }]" />
        <van-field required v-model="Mobile" name="Mobile" label="联系电话" label-width="130" placeholder="请输入联系电话" :rules="[{ required: true, message: '请填写联系电话' }]" />
        <van-field required v-model="Address" name="Address" label="提货地址" placeholder="请输入提货地址" :rules="[{ required: true, message: '请填写提货地址' }]" />

        <van-button round block type="info" native-type="submit" style="margin-top:30%;background-color:#EE7700;border:none;" >提交</van-button>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { addSupplierAddress } from "~/api/supplier";

export default {
  name: "AddAddressView",
  components: {
  },
  data() {
    return {
      ContactName:"",
      Mobile:"",
      Address:"",
    };
  },

  props: {
    show: Boolean,
    SupplierId:Number,
    SupplierName:String
  },

  methods: {
    async onSubmit(data){
      let loading = this.$toast.loading({
        message: "正在保存...",
        forbidClick: true,
        duration: 0,
      });
      try{
        const res = await addSupplierAddress(data);
        loading.clear();
        this.$emit("supplierAddressCb",{AddressId:res,AddressName:this.Address})
      }catch{
        loading.clear();
        Toast.fail("操作失败，请重试！");
      }
    },

    async close(){
      this.$emit("supplierAddressCb",null)
    }
  },

  watch:{
    show:{
      handler(v){
        if(v){
          this.$refs.sAddressForm.resetValidation("");
        }
      }
    }
  }
};
</script>

<style lang="scss" scope>

</style>
